type Offer = {
    id: string
    tier: number
    productIds: { googleplay?: string }
}

export const transformPaymentContractIdsToNativePriceEvent = (
    ids: string[]
): {
    category: string
    offers: Offer[]
    eventName: string
    eventType: string
} =>
    // eslint-disable-next-line unicorn/no-array-reduce
    ids.reduce(
        (prev, cur, idx) => {
            prev.offers.push({
                id: cur,
                tier: 0,
                productIds: {
                    googleplay: cur,
                },
            })
            return prev
        },
        {
            category: 'all',
            offers: [] as Offer[],
            eventName: 'lemonstand.nativePrice',
            eventType: 'bubble',
        }
    )
